/**
 * 吐司提示
 * 支持：success, info, warn, error, loading 三种提示类型
 */
import toast from '@/helpers/toast'

let ToastPlugin = {}

ToastPlugin.install = Vue => {
  Vue.prototype.$toast = toast
}

export default ToastPlugin
